<template>
    <div class="tc-modal-new-case-type-select tc-modal-body">
        <div class="tc-modal-label">
            Создать новый шкаф
        </div>
        <div class="tc-select-new-case-type-grid">
            <div class="tc-select-new-case-type-item"
                 @click.stop="newCase()">
                <img class="tc-new-case-item-img-bg"
                     :src="'./dist/src/img/caseNew.jpg'"
                     alt="newCase">
                <div class="tc-new-case-item-text">
                    Создать новый шкаф с нуля
                </div>
            </div>

            <div class="tc-borderline-padding-10">
                <div class="tc-borderline-vertical"></div>
            </div>

            <div class="tc-select-new-case-type-item"
                 @click.stop="copyCase()">
                <img class="tc-new-case-item-img-bg"
                     :src="'./dist/src/img/caseCopyExists.jpg'"
                     alt="copyCase">
                <div class="tc-new-case-item-text">
                    Создать копию текущего шкафа
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { useStoreUI } from '@/Store/storeUI';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreNotifications } from '@/Store/storeNotifications';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { onStoreUpdateHandler } from '@/Engine/eventHandlers/onStoreUpdate';
import { addNewCaseToList } from '@/libs/addNewCaseToList';

export default {
    name: 'ModalNewCaseTypeSelect',
    setup() {
        const storeUI = useStoreUI();
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const storeNotifications = useStoreNotifications();
        const storeProjectStructure = useStoreProjectStructure();

        return {
            storeUI,
            storeCaseConfiguration,
            storeNotifications,
            storeProjectStructure,
        };
    },
    methods: {
        newCase() {
            this.storeUI.setIsSelectCase(true);
            this.storeUI.setIsShowModal(false);
            this.storeCaseConfiguration.resetStoreConfiguration();
            this.storeProjectStructure.setSelectedCaseId();
            onStoreUpdateHandler();
            this.$router.push({ path: '/selectCase' });
        },
        copyCase() {
            const defaultCaseImageSrc = this.storeProjectStructure.getCaseById(this.storeProjectStructure.selectedCaseId)?.image;
            addNewCaseToList(crypto.randomUUID(), defaultCaseImageSrc);
            this.storeUI.setIsShowModal(false);
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/modal";

.tc-modal-new-case-type-select {
    width: 460px;
}

.tc-select-new-case-type-grid {
    display: grid;
    grid-template-columns: 1fr max-content 1fr;
    grid-column-gap: 15px;
}

.tc-select-new-case-type-item {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: flex-start;
    padding: 10px;
    border: 1px solid transparent;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    transition: 0.3s ease all;
}

.tc-select-new-case-type-item:hover {
    border: 1px solid #D9D9D9;
}

.tc-select-new-case-type-item:active {
    border: 1px solid #00458D;
}

.tc-new-case-item-img-bg {
    width: 100%;
    height: 180px;
    object-fit: cover;
    background-color: #F2F2F2;
}

.tc-new-case-item-text {
    color: #00458D;
    font-size: 16px;
    text-align: center;
    display: flex;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
}

.tc-borderline-padding-10 {
    padding: 10px;
    box-sizing: border-box;
    width: max-content;
    height: 100%;
}
</style>
